/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useZuschlagsgruppen } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useZuschlagsgruppen/useZuschlagsgruppen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerTrigger,
  ScrollArea,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui';
import { faAngleDown, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ZuschlagsgruppeSelect() {
  const { currentStandort } = useStandortContext();
  const { zuschlagsgruppen } = useZuschlagsgruppen(currentStandort.id);
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  return (
    <form.AppField
      name="bezahlung.zuschlaege.zuschlagsgruppe"
      listeners={{
        onChange: () => {
          ctx.validateCurrentSubStep();
        },
      }}>
      {(field) => (
        <FieldBase
          label={t(
            'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.label',
          )}>
          <Select
            value={field.state.value ?? undefined}
            onValueChange={(val) => {
              if (val === 'reset') {
                field.handleChange(null);
              } else {
                field.handleChange(val);
              }
            }}>
            <SelectTrigger className="w-full max-w-96 overflow-hidden md:flex hidden">
              <SelectValue
                placeholder={t(
                  'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.placeholder',
                )}
              />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="reset">
                <p className="truncate text-primary-blue-600 text-sm font-bold leading-5">
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.resetItem',
                  )}
                </p>
              </SelectItem>
              {zuschlagsgruppen.map((zuschlagsgruppe) => (
                <SelectItem key={zuschlagsgruppe.id} value={zuschlagsgruppe.id}>
                  <p className="truncate">{zuschlagsgruppe.name}</p>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Drawer
            open={isDrawerOpen}
            onOpenChange={(open) => setIsDrawerOpen(open)}>
            <DrawerTrigger asChild>
              <Button
                variant={'outline-secondary'}
                className="md:hidden flex flex-row justify-between gap-1 w-full text-neutrals-900 text-sm font-normal max-w-96 border-neutrals-200 hover:bg-neutrals-100"
                role="combobox">
                {field.state.value ? (
                  <span className="truncate">
                    {
                      zuschlagsgruppen.find(
                        (val) => val.id === field.state.value,
                      )?.name
                    }
                  </span>
                ) : (
                  <span className="text-neutrals-700">
                    {t(
                      'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.placeholder',
                    )}
                  </span>
                )}
                <FontAwesomeIcon icon={faAngleDown} className="h-4 w-4" />
              </Button>
            </DrawerTrigger>
            <DrawerContent className="flex flex-col gap-4 p-4">
              <div className="font-semibold text-center">
                {t(
                  `domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.label`,
                )}
              </div>

              <ScrollArea className="overflow-auto max-h-108">
                <div className="flex flex-col gap-2">
                  <div
                    className="flex justify-between items-center gap-2 not-last:border-b border-neutrals-200 pb-2"
                    key="reset"
                    onClick={() => {
                      field.handleChange(null);
                      setIsDrawerOpen(false);
                    }}>
                    <span className="text-primary-blue-600 text-sm font-bold leading-5">
                      {t(
                        'domain.mitarbeiter.create.steps.bezahlung.zuschlaege.form.zuschlagsgruppe.resetItem',
                      )}
                    </span>
                  </div>
                  {zuschlagsgruppen.map((zuschlagsgruppe) => (
                    <div
                      className="flex justify-between items-center gap-2 not-last:border-b border-neutrals-200 pb-2"
                      key={zuschlagsgruppe.id}
                      onClick={() => {
                        field.handleChange(zuschlagsgruppe.id);
                        setIsDrawerOpen(false);
                      }}>
                      <span>{zuschlagsgruppe.name}</span>
                      {field.state.value === zuschlagsgruppe.id && (
                        <FontAwesomeIcon
                          className="text-primary-blue-600 pr-2"
                          icon={faCheck}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </ScrollArea>
            </DrawerContent>
          </Drawer>
        </FieldBase>
      )}
    </form.AppField>
  );
}
